import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import Selector2 from "../Selector2";
import { images } from "../../utils/images";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  fetchCountries,
  fetchTerritories,
  pushNotification,
} from "../../actions/index";

function BankDetails(props) {
  const { t, classes, countries, territories } = props;
  const [bankName, setBankName] = useState("");
  const [bankAddress, setBankAddress] = useState("");
  const [bankCity, setBankCity] = useState("");
  const [bankState, setBankState] = useState("");
  const [bankZipcode, setBankZipcode] = useState("");
  const [bankCountry, setBankCountry] = useState("");
  const [countriesArr, setCountries] = useState([]);
  const [territoriesArr, setTerritories] = useState([]);

  const [missingFields, setMissingFields] = useState([]);

  useEffect(() => {
    if (countries) {
      let arr = [];

      countries.map((c) => {
        arr.push(c.name);
      });

      setCountries([...arr]);
    } else {
      props.fetchCountries();
    }
  }, [countries]);

  useEffect(() => {
    if (bankCountry) {
      let countryFound = countries.find((c) => c.name === bankCountry);

      props.fetchTerritories({ code: countryFound.alpha2 });
    }
  }, [bankCountry]);

  useEffect(() => {
    if (territories) {
      setTerritories([...territories]);
    }
  }, [territories]);

  const bankDetailsInputs = [
    {
      id: "name",
      label: "_bankName",
      modifier: setBankName,
      value: bankName,
    },
    {
      id: "address_line_1",
      label: "_bankAddress",
      modifier: setBankAddress,
      value: bankAddress,
    },
    {
      id: "country",
      label: "_bankCountry",
      modifier: setBankCountry,
      value: bankCountry,
      type: "selector",
      options: countriesArr,
      placeholder: "_country",
    },
    {
      id: "city",
      label: "_bankCity",
      modifier: setBankCity,
      value: bankCity,
    },
    {
      id: "territory",
      label: "_bankState",
      modifier: setBankState,
      value: bankState,
      type: "selector",
      options: territoriesArr,
      placeholder: "_territory",
    },
    {
      id: "postcode",
      label: "_bankZipcode",
      modifier: setBankZipcode,
      value: bankZipcode,
    },
  ];

  const validateDataAndProceed = async () => {
    let countryFound = countries.find((c) => c.name === bankCountry);

    let bankDetailsObj = {
      name: bankName,
      country: countryFound ? countryFound.alpha2 : "",
      territory: bankState,
      address_line_1: bankAddress,
      city: bankCountry,
      postcode: bankZipcode,
    };

    setMissingFields([]);
    let missingFieldsArr = [];

    Object.entries(bankDetailsObj).map((entry) => {
      if (entry[1] === "") {
        missingFieldsArr.push(entry[0]);
      }
    });

    if (missingFieldsArr.length) {
      setMissingFields([...missingFieldsArr]);
      props.pushNotification({ message: "missingFields", type: "error" });
      return;
    }

    await props.setBankDetails(bankDetailsObj);
    await props.trigger(true);
  };

  return (
    <div className="corporateStepContainer">
      <h2 dangerouslySetInnerHTML={{ __html: t("_corporateT4") }} />
      <p>{t("_corporateP1")}</p>
      <div className={`inputsContainer ${classes.inputRows}`}>
        <div className="left">
          <p className="label">{t("_bankDetailsCopy")}</p>
          {bankDetailsInputs.map((i, idx) => {
            if (i.type && i.type === "selector") {
              return (
                <Selector2
                  key={idx}
                  selectedOption={i.value}
                  selectorHandle={i.modifier}
                  options={i.options}
                  disabled={i.options.length ? false : true}
                  placeholder={t(i.placeholder)}
                  invalid={missingFields.includes(i.id) ? true : false}
                />
              );
            }
            return (
              <input
                type="text"
                key={idx}
                placeholder={t(i.label)}
                onChange={(e) => i.modifier(e.target.value)}
                value={i.value}
                className={missingFields.includes(i.id) ? "invalidField" : ""}
              />
            );
          })}
        </div>
        <div className="right">
          <img src={images.illustrations.corpSolo4} />
        </div>
      </div>
      <div className="nextButtonContainer">
        <button onClick={() => validateDataAndProceed()}>{t("next")}</button>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    countries: state.countries,
    territories: state.territories,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchCountries,
      fetchTerritories,
      pushNotification,
    },
    dispatch
  );
}

const styles = (theme) => ({
  inputRows: {
    "& .label": {
      marginBottom: 4,
    },
    "& input": {
      ...theme.defaults.input,
      maxWidth: "none",
      marginBottom: 8,
      marginTop: 8,
      "&.invalidField": {
        borderColor: theme.colors.buttons.sell,
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(connect(mapStateToProps, mapDispatchToProps)(BankDetails))
);
